import TranslationService from "../services/TranslationService";
import Vue from "vue";

function decodeItemName(value)
{
    if (typeof value !== "string" || value.length === 0)
    {
        return value;
    }

    // Item names can arrive pre-escaped (&amp;#039; / &#039;), so normalize before rendering.
    return value
        .replace(/&amp;(?=#\d+;|#x[0-9a-f]+;|[a-z]+;)/gi, "&")
        .replace(/&#0*39;|&apos;/gi, "'")
        .replace(/&quot;/gi, "\"")
        .replace(/&amp;/gi, "&");
}

Vue.filter("itemName", ({ texts:{ name1, name2, name3 }, variation:{ name, bundleType } }, selectedName = App.config.item.itemName, itemDisplayName = App.config.item.displayName) =>
{
    let itemName = "";

    if (selectedName === 1 && name2 !== "")
    {
        itemName = name2;
    }
    else if (selectedName === 2 && name3 !== "")
    {
        itemName = name3;
    }
    else
    {
        itemName = name1;
    }

    if (itemDisplayName === "itemNameVariationName" && name && name.length)
    {
        itemName = `${itemName} ${name}`;
    }

    if (itemDisplayName === "variationName" && name && name.length)
    {
        itemName = name;
    }

    if (bundleType === "bundle")
    {
        itemName = TranslationService.translate("Ceres::Template.itemBundleName", { itemName });
    }

    return decodeItemName(itemName);
});
